import theme from "@/theme";
import { Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface AboutYourHealthScoreData {
  title: string;
  titleColor: keyof Theme["palette"] | string;
  range: string;
  description: string;
}

export function useGetAboutYourHealthScoreData() {
  const { t } = useTranslation();

  const aboutYourHealthScoreData: AboutYourHealthScoreData[] = [
    {
      title: t("WellnessStatus.healthy"),
      titleColor: theme.palette.accent1.main,
      range: "60 - 100",
      description: t("WellnessStatus.healthy.description"),
    },
    {
      title: t("WellnessStatus.needsAttention"),
      titleColor: theme.palette.secondary.dark,
      range: "40 - 60",
      description: t("WellnessStatus.needsAttention.description"),
    },
    {
      title: t("WellnessStatus.needsSupport"),
      titleColor: theme.palette.accent4.main,
      range: "0 - 40",
      description: t("WellnessStatus.needsSupport.description"),
    },
  ];
  return {
    aboutYourHealthScoreData,
  };
}
